if (window.location.pathname == '/contact') {
    window.contactMap = function () {
        if (typeof latlng == 'string') {
            var latlng = latlng.split(',');
            restaurantlatlng = {
                lat: parseFloat(latlng[0]),
                lng: parseFloat(latlng[1])
            }
        }

        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            latLng: restaurantlatlng
        }, function (res, st) {

            var map = new google.maps.Map(document.getElementById('map'), {
                center: restaurantlatlng,
                zoom: 14
            });
            if (panoramaStatus == '1') {
                var panorama = new google.maps.StreetViewPanorama(
                    document.getElementById('pano'), {
                        position: restaurantlatlng,
                        pov: {
                            heading: 100,
                            pitch: 10
                        }
                    });
                map.setStreetView(panorama);
            } else {
                
                var infowindow = new google.maps.InfoWindow({
                    content: res[0].formatted_address
                });

                var marker = new google.maps.Marker({
                    position: restaurantlatlng,
                    map: map
                });

                infowindow.open(map, marker);
            }
        })
    }
}